import React, { useState, useEffect } from 'react';
import './mission.css';
import HeadingContainer from '../heading-container/HeadingContainer';
import { Typography, Container, Box } from '@mui/material';

function Mission() {
    const [missionData, setMissionData] = useState("");
    const [missionHeading, setMissionHeading] = useState("");
    const [visionData, setVisionData] = useState("");
    const [visionHeading, setVisionHeading] = useState("");
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        Promise.all([
            fetch(`${process.env.REACT_APP_BACKEND_BASE_URI}/secure/admin/get/mission`).then(res => res.json()),
            fetch(`${process.env.REACT_APP_BACKEND_BASE_URI}/secure/admin/get/vision`).then(res => res.json())
        ]).then(([missionRes, visionRes]) => {
            if (missionRes && missionRes.length > 0) {
                setMissionHeading(missionRes[0].heading);
                setMissionData(missionRes[0].details);
            }
            if (visionRes && visionRes.length > 0) {
                setVisionHeading(visionRes[0].heading);
                setVisionData(visionRes[0].details);
            }
            setLoading(false);
        }).catch(err => {
            console.error("Error fetching mission/vision:", err);
            setLoading(false);
        });
    }, []);

    return (
        <>
            <HeadingContainer title="Mission & Vision" />
            <div className="mission-wrapper">
                <Container maxWidth="md">
                    {loading ? (
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px' }}>
                            <div className="spinner" style={{ border: '4px solid rgba(0,0,0,0.1)', width: '36px', height: '36px', borderRadius: '50%', borderLeftColor: 'var(--primary)', animation: 'spin 1s linear infinite' }}></div>
                            <style>{`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
                        </div>
                    ) : (
                        <>
                            <Box className="mission-card hover-scale" mb={6}>
                                <div className="mission-icon-bg">🎯</div>
                                <h2 className="mission-title">{missionHeading}</h2>
                                <h3 className="mission-quote">"It is easier to follow the leader than to lead the follower.”</h3>
                                <Typography variant="body1" className="mission-text" style={{ whiteSpace: 'pre-line' }}>
                                    {missionData}
                                </Typography>
                            </Box>

                            <Box className="vision-card hover-scale">
                                <div className="mission-icon-bg">👁️‍🗨️</div>
                                <h2 className="mission-title" style={{ color: 'var(--secondary)' }}>{visionHeading}</h2>
                                <h3 className="mission-quote">“Education's purpose is to replace an empty mind with an open one.”</h3>
                                <Typography variant="body1" className="mission-text" style={{ whiteSpace: 'pre-line' }}>
                                    {visionData}
                                </Typography>
                            </Box>
                        </>
                    )}
                </Container>
            </div>
        </>
    );
}

export default Mission;